module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "sedac-popdensity-yeargrid5yr-v4.11.thumbnails.population.density.5404e1c1.png";